import ConfirmModal from '../../common/components/Modal/ConfirmModal.js'
import {
  formsSelector,
  onlyIfForm,
  removeForm,
  setForm,
  updateForm,
} from '../../store.js'

const MODAL_FORM = 'video_modal'

export function showVideoModal({videoID}) {
  setForm(MODAL_FORM, {videoID})
}

export function updateModalForm(...args) {
  updateForm(MODAL_FORM, ...args)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  return formsSelector(state)[MODAL_FORM]
}

function VideoModal({form}) {
  return (
    <ConfirmModal
      title="A Video"
      className="modal--yt-video"
      modalSize="x-lg"
      onCancel={() => closeModal()}
      cancelText="Close"
    >
      <iframe
        title="Ordoro Feature Video"
        className="iframe--yt-16-9"
        id="player"
        type="text/html"
        src={`https://www.youtube.com/embed/${form.videoID}?autoplay=1&rel=0`}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      ></iframe>
    </ConfirmModal>
  )
}

export default onlyIfForm(VideoModal, modalFormSelector)
